$(document).ready(function(){
  $('.slick-carousel').slick({
    arrows: false,
    autoplay:true,
    centerPadding: "0px",
    dots: true,
    fade: true,
    speed: 200,
    slidesToShow: 1,
    infinite: true,
    pauseOnHover:false
  });
});
// $("ul.pagination__list.list-unstyled li a.pagination__item.link").click(function(e){
// e.preventDefault();
// var data_url = $(this).attr("href");
// window.location.replace(data_url);
// });